export default "__VITE_ASSET__4wgHRj$I__"